import {Theme} from "@mui/material";
import {SxType} from "@baseTypes/sx/sxTypes";
import {FRAME_BORDER_SYNC, RADIUS_SYNC} from "@containers/singleVoyage/voyageTemplates/sync/theme";

const thinScroll = {
	scrollbarWidth: 'thin',
	scrollbarColor: 'rgba(128, 128, 128, 0.4) transparent',
}

export const sx: SxType = {
	// the app's modal paper is grey; the content sits on the regular surface for contrast
	// a fixed 1000px in the windowed modal whatever the content, so switching voyages never resizes
	// it; the fullscreen modal sets a near-full-screen min width, and minWidth 100% follows it
	root: {
		width: {xs: '100%', md: '1000px'},
		minWidth: '100%',
		boxSizing: 'border-box',
		gap: '14px',
		p: {xs: '12px', md: '16px 20px'},
		bgcolor: 'background.paper',
		borderRadius: RADIUS_SYNC,
	},
	// about the height of the loaded window: the top row plus the body below
	loading: {
		position: 'relative',
		height: {xs: '320px', md: 'calc(100vh - 100px)'},
	},
	top: {
		flexDirection: {xs: 'column', md: 'row'},
		justifyContent: 'space-between',
		alignItems: {xs: 'stretch', md: 'flex-start'},
		gap: '12px',
	},
	header: {
		gap: '4px',
		minWidth: 0,
	},
	topActions: {
		alignItems: 'flex-end',
		gap: '4px',
		flexShrink: 0,
	},
	summary: {
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '8px',
	},
	summaryTitle: {
		fontSize: '16px',
		fontWeight: 600,
		mr: '4px',
	},
	summaryChip: {
		fontSize: '12px',
		fontWeight: 600,
		px: '10px',
		py: '3px',
		borderRadius: '12px',
	},
	ok: {
		color: (theme: Theme) => theme.palette.mode === 'dark' ? '#81C784' : '#1B5E20',
		bgcolor: 'rgba(46, 125, 50, 0.16)',
	},
	warn: {
		color: (theme: Theme) => theme.palette.mode === 'dark' ? '#FFB74D' : '#A35200',
		bgcolor: 'rgba(224, 122, 16, 0.16)',
	},
	fail: {
		color: (theme: Theme) => theme.palette.mode === 'dark' ? '#E57373' : '#B71C1C',
		bgcolor: 'rgba(211, 47, 47, 0.16)',
	},
	hint: {
		fontSize: '13px',
		color: 'text.secondary',
	},
	// sized to the window so the footer with the action buttons never scrolls out of view
	body: {
		display: 'grid',
		gridTemplateColumns: {xs: '1fr', md: '290px minmax(0, 1fr)'},
		height: {md: 'calc(100vh - 200px)'},
		minHeight: {md: '320px'},
		border: FRAME_BORDER_SYNC,
		borderRadius: RADIUS_SYNC,
		overflow: 'hidden',
	},
	list: {
		gap: '8px',
		overflowY: 'auto',
		p: '12px',
		borderRight: {md: FRAME_BORDER_SYNC},
		borderBottom: {xs: FRAME_BORDER_SYNC, md: 'none'},
		bgcolor: 'background.paper',
		...thinScroll,
	},
	detail: {
		minWidth: 0,
		overflowY: 'auto',
		p: {xs: '14px', md: '18px 22px'},
		bgcolor: 'background.paper',
		...thinScroll,
	},
	warning: {
		maxWidth: '360px',
		textAlign: 'right',
		fontSize: '12px',
		color: (theme: Theme) => theme.palette.mode === 'dark' ? '#FFB74D' : '#A35200',
	},
	actions: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		gap: '8px',
		flexShrink: 0,
	},
	empty: {
		width: {xs: '100%', md: '440px'},
		maxWidth: '100%',
		alignItems: 'center',
		textAlign: 'center',
		gap: '12px',
		py: '36px',
		px: '20px',
		bgcolor: 'background.paper',
	},
	emptyIcon: {
		fontSize: '44px',
		color: '#2E7D32',
	},
	emptyTitle: {
		fontSize: '15px',
	},
}
